import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';
import { availableLanguages } from '../translations';

const LandingPage = () => {
  const { t, isRTL, currentLanguage, changeLanguage } = useLanguage();

  const handleLanguageChange = async (e) => {
    const newLanguage = e.target.value;
    await changeLanguage(newLanguage);
  };

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('safaCards')}</h1>
        <p className="tagline">{t('intelligentWayToMaster')}</p>
        <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
          <label htmlFor="language-selector" style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontSize: '0.9rem',
            color: '#666',
            fontWeight: 500
          }}>
            {t('appLanguage') || 'App Language'}:
          </label>
          <select
            id="language-selector"
            value={currentLanguage}
            onChange={handleLanguageChange}
            style={{
              padding: '0.6rem 1rem',
              borderRadius: '8px',
              border: '1px solid #ddd',
              fontSize: '1rem',
              backgroundColor: '#fff',
              color: '#333',
              cursor: 'pointer',
              minWidth: '180px',
              fontFamily: 'inherit'
            }}
          >
            {availableLanguages.map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.nativeName}
              </option>
            ))}
          </select>
        </div>
      </header>

      <main className="landing-main">
        <div className="hero-section">
          <h2>{t('learnLanguagesSmartWay')}</h2>
          <p>{t('landingDescription')}</p>
          <Link to="/login" className="btn btn-primary cta-button">{t('startLearningFree')}</Link>
        </div>

        <div className="blog-card" style={{ marginTop: '2rem', background: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', textAlign: 'center', maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
          <h3 style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }}>{t('blog') || 'Blog'}</h3>
          <p style={{ marginBottom: '0.8rem', color: '#333', fontSize: '1.05rem', lineHeight: '1.5', fontWeight: 500 }}>{t('blogCardTitle') || 'Expert Language Learning Insights'}</p>
          <p style={{ marginBottom: '1.2rem', color: '#555', fontSize: '0.95rem', lineHeight: '1.6' }}>{t('blogCardDescription') || 'Discover science-backed strategies, practical tips, and proven methods to accelerate your language learning journey. Our blog features in-depth articles on spaced repetition, memory techniques, cultural understanding, and more.'}</p>
          <Link to="/blog" className="btn btn-primary">{t('visitBlog') || 'Visit Blog'}</Link>
        </div>

        <div className="demo-wordgroup-card" style={{ marginTop: '2rem', background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', textAlign: 'center', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>
          <h3 style={{ marginBottom: '0.5rem' }}>{t('wantToSeeSample')}</h3>
          <p style={{ marginBottom: '1.2rem', color: '#555' }}>{t('previewWordGroup')}</p>
          <Link to="/module/demo/group/0" className="btn btn-secondary">{t('viewDemoWordgroup')}</Link>
        </div>

        <div className="how-to-use-card" style={{ marginTop: '2rem', background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', textAlign: 'center', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>
          <h3 style={{ marginBottom: '0.5rem' }}>{t('wantTipsOnSafaCards')}</h3>
          <p style={{ marginBottom: '1.2rem', color: '#555' }}>{t('checkOutQuickStart')}</p>
          <Link to="/howtouse" className="btn btn-secondary">{t('viewHowToGuide')}</Link>
        </div>

        <div className="how-to-use-card" style={{ marginTop: '1rem', background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', textAlign: 'center', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>
          <h3 style={{ marginBottom: '0.5rem' }}>{t('sm2GuideCardTitle') || 'Spaced Repetition (SM‑2) Guide'}</h3>
          <p style={{ marginBottom: '1.2rem', color: '#555' }}>{t('sm2GuideCardDesc') || 'Learn how to use Learning Mode first, then Review All Words (SM‑2) to retain faster.'}</p>
          <Link to="/guide/sm2" className="btn btn-secondary">{t('sm2GuideCardCTA') || 'Read the SM‑2 Guide'}</Link>
        </div>

        <section className="features-section">
          <h3>{t('coreFeatures')}</h3>
          <div className="features-grid">
            <div className="feature-card">
              <h4>{t('smartVocabularyLists')}</h4>
              <p>{t('smartVocabularyDescription')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('learnInContext')}</h4>
              <p>{t('learnInContextDescription')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('practiceWithAI')}</h4>
              <p>{t('practiceWithAIDescription')}</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default LandingPage; 